'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ButtonLink } from '@kiao-voice/ui-kit'
import { InkHero } from '@/components/site/ink-hero'
import { useAuthModal } from '@/features/auth/auth-modal-provider'
import { smoothScrollToAnchor } from '@/lib/smooth-scroll'
import { trackSiteLinkClicked } from '@/lib/analytics'

export function MeetingNotesHero() {
  const { t } = useTranslation(['web'])
  const { open } = useAuthModal()
  return (
    <InkHero
      eyebrow={t('web:meetingNotesPage.hero.eyebrow')}
      titleKey="web:meetingNotesPage.hero.title"
      lead={t('web:meetingNotesPage.hero.lead')}
      copyWidth="wide"
      titleSize="compact"
      actions={
        <>
          <Button variant="brand" size="marketing" onClick={() => open()}>
            {t('web:meetingNotesPage.hero.primaryCta')}
          </Button>
          <ButtonLink
            variant="secondary"
            size="marketing"
            href="#sample"
            onClick={(event) => {
              trackSiteLinkClicked('hero', '#sample')
              smoothScrollToAnchor(event)
            }}
          >
            {t('web:meetingNotesPage.hero.secondaryCta')}
          </ButtonLink>
        </>
      }
      meta={t('web:meetingNotesPage.hero.meta')}
    />
  )
}
